/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { scenarioItemBulkEditRequestSchema } from './scenarioItemBulkEditRequestSchema';

export const scenarioItemBulkEditStageRequestSchema = z.object({
  get request() {
    return scenarioItemBulkEditRequestSchema;
  },
  sessionId: z.string().min(1),
});
